import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

const store = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    preloadedState,
  });
};

export default store;
